<section>
  <div class="details">
    <div class="icon">
      <mat-icon aria-hidden="true">home</mat-icon>
    </div>
    <div class="title">
      <span class="body1 lab-name">{{ lab().laboratoryName }}</span>
      <span class="body1 role">{{ role() | formatRole }}</span>
    </div>
  </div>
  @if (readonly()) {
    <app-status-indicator status="active"></app-status-indicator>
  }
  @if (!readonly()) {
    <app-mat-icon-button
      buttonId="remove-lab-btn"
      iconName="close"
      buttonStyle="dark-blue"
      [ariaLabel]="'Remove ' + lab().laboratoryName"
      (buttonClicked)="onRemove()"
    ></app-mat-icon-button>
  }
</section>
